export const DEFAULT_COUNTRY_CODE = 'KR'

export const normalizeCountryCode = (
  countryCode: string | null | undefined,
  fallbackCountryCode = DEFAULT_COUNTRY_CODE,
): string => {
  const normalizedCountryCode = countryCode?.trim().toUpperCase()

  return normalizedCountryCode || fallbackCountryCode
}

export const normalizeOptionalCountryCode = (countryCode: string | null | undefined): string | null => {
  const normalizedCountryCode = countryCode?.trim().toUpperCase()

  return normalizedCountryCode || null
}
